import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute, DashboardRedirect } from "@/lib/auth";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import BuyerDashboard from "@/pages/BuyerDashboard";
import BuyerOrderDetail from "@/pages/BuyerOrderDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUsers from "@/pages/AdminUsers";
import AdminLeads from "@/pages/AdminLeads";
import AdminExcelUpload from "@/pages/AdminExcelUpload";
import ActivityLogs from "@/pages/ActivityLogs";
import ProfilePage from "@/pages/ProfilePage";
import InternalDashboard from "@/pages/InternalDashboard";
import MerchantDashboard from "@/pages/MerchantDashboard";
import OrderDetail from "@/pages/OrderDetail";
import InviteAccept from "@/pages/InviteAccept";
import FloorDataPage from "@/pages/FloorDataPage";
import FloorDetailPage from "@/pages/FloorDetailPage";


function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/invite/:token" element={<InviteAccept />} />
          <Route path="/dashboard" element={<DashboardRedirect />} />
          <Route path="/dashboard/buyer" element={
            <ProtectedRoute roles={["buyer"]}><BuyerDashboard /></ProtectedRoute>
          } />
          <Route path="/dashboard/buyer/orders/:id" element={
            <ProtectedRoute roles={["buyer"]}><BuyerOrderDetail /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/users" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminUsers /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/leads" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><AdminLeads /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/upload" element={
            <ProtectedRoute roles={["super_admin"]}><AdminExcelUpload /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/activity" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><ActivityLogs /></ProtectedRoute>
          } />
          <Route path="/dashboard/profile" element={
            <ProtectedRoute roles={["admin", "super_admin", "merchant", "buyer", "internal"]}><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/orders/:id" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><OrderDetail /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/floor" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><FloorDataPage /></ProtectedRoute>
          } />
          <Route path="/dashboard/admin/floor/:orderId" element={
            <ProtectedRoute roles={["admin", "super_admin"]}><FloorDetailPage /></ProtectedRoute>
          } />
          <Route path="/dashboard/internal" element={
            <ProtectedRoute roles={["internal"]}><InternalDashboard /></ProtectedRoute>
          } />
          <Route path="/dashboard/internal/orders/:id" element={
            <ProtectedRoute roles={["internal"]}><OrderDetail /></ProtectedRoute>
          } />
          <Route path="/dashboard/internal/floor" element={
            <ProtectedRoute roles={["internal"]}><FloorDataPage /></ProtectedRoute>
          } />
          <Route path="/dashboard/internal/floor/:orderId" element={
            <ProtectedRoute roles={["internal"]}><FloorDetailPage /></ProtectedRoute>
          } />
          <Route path="/dashboard/merchant" element={
            <ProtectedRoute roles={["merchant"]}><MerchantDashboard /></ProtectedRoute>
          } />
          <Route path="/dashboard/merchant/orders/:id" element={
            <ProtectedRoute roles={["merchant"]}><OrderDetail /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
